<div class="cancel-freshpass-container">
  <div class="cancel-fp-customer-details-container" *ngIf="userSubscriptionDetails">
    <app-customer-details-header-v2 [displaySubTypeLink]="displaySubTypeLink"
      [userSubscriptionDetails]="userSubscriptionDetails">
    </app-customer-details-header-v2>
  </div>
  <div id="sub-summary-cancel-plans container" *ngIf="!displayDiscountSelection;">
    <div *ngIf="!showLoader">
      <div class="cancel-error-container mb16 error-border" *ngIf="isServiceError">
        <div class="message-center border-box">
              <img alt="red cross error image" aria-hidden="true" class="red-cross-error-icon"
                src="ocsp-web-ui/dist/assets/images/error-close-icon.svg">
          <span class="error-messages-center">{{errorMessage}}</span>
        </div>
      </div>
      <div class="cancel-plan-title-container">
        <div>
          <h2 id="dsCancelPlanId" class="cancel-plan-title">
            Sorry to see you go
          </h2>
        </div>
        <div *ngIf="currentPlanExpiryDate" [attr.aria-labelledby]="'refundEligibilityLabel refundEligibilityExpiryDateLabel'"
          class="cancel-plan-sub-title mb24">
          <span id="refundEligibilityLabel">
          {{ cancelUserEligibilityData?.isRefundEligible
            ? properties.cancelFreshPass.infoMsgForFPCancelRefundEligible
            : properties.cancelFreshPass.infoMsgForFPCancelRefundNotEligible }}
          </span>
          <span id="refundEligibilityExpiryDateLabel" aria-hidden="true" [attr.aria-label]="formattedExpiryDate">
            {{ currentPlanExpiryDate }}.
          </span>
          <span class="sr-only">{{formattedExpiryDate}}</span>
        </div>
      </div>
      <hr class="mb24" />
      <div class="mb16">
        Before you go, please tell us why you’re not keeping your FreshPass subscription.
      </div>


      <form [formGroup]="cancelReasonForm">
        <fieldset>
          <legend>Reason for Cancellation</legend>
          <div>
            <div class="">
              <!--Remove this wrapper and p tag on actual implementation -->
              <div aria-invalid="false" aria-labelledby="cancelReasonTitle" class="cancel-plan-form-control valid"
                id="dsCancelReasons">
                <div *ngFor="let reason of cancelReasonsList; let i = index" class="cancel-reason-div">
                  <div class="col-xl-9 col-lg-9 col-md-9 col-sm-12 col-12 cancel-reason-item"
                    [ngClass]="{'cancel-item-selected': selectedReason === reason.ID}">
                    <label class="d-flex pds-radio cancel-radio-label">
                      <input (change)="handleChange($event, reason.ID, reason.Reason)"
                        aria-label="Reason for Cancellation(select one) {{reason.ID}} radio button {{ i + 1 }} of {{cancelReasonsList.length + 1}} checked"
                        formControlName="cancelChoice" id="{{reason.ID}}" type="radio" aria-checked="true"
                        value="{{reason.ID}}" name="cancelChoice" checked>
                      <span class="d-flex align-items-center justify-content-center pds-radio-bullet-container">
                        <span class="pds-radio-bullet"></span>
                      </span>
                      <span class="cancel-reason-text ml-2 pds-radio-label">{{reason.Reason}}</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="cancelFeedbackLabel">
                  <p class="cancel-feedback-title" id="cancelFeedbackLabel">
                    Additional Comments (optional)
                  </p>
                </label>
                <div class="cancel-feedback-container">
                  <textarea (keyup)="displayCharCount($event)"
                    class="cancel-feedback" formControlName="cancelFeedback" id="dsCancelFeedback" maxlength="400"
                    placeholder="Additional feedback (optional)" aria-describedby="commentCharCount-sr"></textarea>
                  <div aria-hidden="true" class="feedback-char-count" id="commentCharCount">0/400
                  </div>
                  <div class="sr-only" id="commentCharCount-sr" aria-live="polite" aria-atomic="true">400 Characters remaining out of 400 characters</div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="continue-cancel-container">
              
              <div class="col-xl-5 col-lg-5 col-md-5 col-sm-5 col-5 cancel-btn-no-padding">
                <button (click)="retentionCheckCancelSubscriptionPlan()" [disabled]="!isFormValueValid"
                  aria-label="Continue, Cancel Plan" class="btn btn-primary" id="dsCancelPlanCTAId" tabindex="0">
                  Continue
                </button>
              </div>
            </div>
            <div class="keep-plan-container">
              <div class="cancel-reminder-text">
                Just a reminder
              </div>
              <div class="cancel-email-reminder-text">
                You will be emailed a renewal reminder before your subscription ends
              </div>
              <div class="col-xl-5 col-lg-5 col-md-5 col-sm-5 col-5 cancel-btn-no-padding">
                <button (click)="keepPlanLoad()" aria-label="No, Keep my Plan" class="btn btn-secondary" tabindex="0">
                  Keep my Plan
                </button>
              </div>
            </div>
          </div>
        </fieldset>
      </form>
    </div>
  </div>
  <div *ngIf="displayDiscountSelection">
    <app-cancel-freshpass-discounts-selection 
      [userSubscriptionDetails]="userSubscriptionDetails" 
      [retentionPlanDiscounts]="retentionPlanDiscounts"
      (cancelPlan)="cancelPlan()" [isServiceError]="isServiceError$"
      [errorMessage]="errorMessage"
      (getDiscountOptionSelected)="getDiscountOptionSelected($event)"
      [cancelBenefitsTilesJSON]="cancelBenefitsTilesJSON"
      (updateSubscription)="updateSubscription()" (onErrorChange)="onErrorChange($event)">
    </app-cancel-freshpass-discounts-selection>
  </div>
</div>